import { NotificationSchema } from './types/notificationSchema';
import { createEntityAdapter, createSlice, PayloadAction, Update } from '@reduxjs/toolkit';

import { INotification } from '../../../Notification/types/types';
import { getNotification, loadMoreNotification } from './action';

const notificationAdapter = createEntityAdapter<INotification>();

const initialNotificationState = notificationAdapter.getInitialState();

const initialState: NotificationSchema = {
    notifications: initialNotificationState,
    notificationLoading: false,
    notificationErrors: '',
    isLastPage: false,
    currentPage: 1,
};

let previousState: INotification[] = [];

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        lastPageChange: (state, { payload }: PayloadAction<boolean>) => {
            state.isLastPage = payload;
        },
        changeNotificationMany: (state, { payload }: PayloadAction<Update<INotification>[]>) => {
            notificationAdapter.updateMany(state.notifications, payload);
        },
        markAllAsViewed: (state) => {
            previousState = Object.values(state.notifications.entities) as INotification[];
            const updates = Object.values(state.notifications.entities).map(
                (notification: INotification) => ({
                    id: notification.id,
                    changes: { is_viewed: true },
                })
            );

            notificationAdapter.updateMany(state.notifications, updates);
        },
        rollbackViewedNotifications: (state) => {
            notificationAdapter.setAll(state.notifications, previousState);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotification.pending, (state: NotificationSchema) => {
                state.notificationLoading = true;
                state.notificationErrors = '';
            })
            .addCase(
                getNotification.fulfilled,
                (state: NotificationSchema, { payload }: PayloadAction<INotification[]>) => {
                    notificationAdapter.addMany(state.notifications, payload);
                    state.notificationLoading = false;
                }
            )
            .addCase(
                getNotification.rejected,
                (state: NotificationSchema, { payload }: PayloadAction<string>) => {
                    state.notificationLoading = false;
                    state.notificationErrors = payload;
                }
            )
            .addCase(loadMoreNotification.pending, (state: NotificationSchema) => {
                state.notificationLoading = true;
                state.notificationErrors = '';
            })
            .addCase(
                loadMoreNotification.fulfilled,
                (state: NotificationSchema, { payload }: PayloadAction<INotification[]>) => {
                    notificationAdapter.addMany(state.notifications, payload);
                    state.notificationLoading = false;
                }
            )
            .addCase(
                loadMoreNotification.rejected,
                (state: NotificationSchema, { payload }: PayloadAction<string>) => {
                    state.notificationLoading = false;
                    state.notificationErrors = payload;
                }
            );
    },
});

//@ts-ignore
export const notificationSelector = notificationAdapter.getSelectors(
    //@ts-ignore
    (state) => state.notificationReducer.notifications
);

export const { actions: notificationActions } = notificationSlice;
export const { reducer: notificationReducer } = notificationSlice;
